export default __webpack_public_path__ + "static/media/bg.709f646f.jpg";